import apiClient from "../baseUrl/axiosConfig";

export const sendContactMessage = async (payload) => {
  return await apiClient.post('/contact', payload);
}; 